const primaryCareSpecialties = ['Family Medicine', 'Primary Care Physician', 'Internal Medicine', 'General Practice', 'Pediatrics', 'Sports Medicine', 'Geriatric Medicine']

const isPrimaryCare = (specialties) => {
    return specialties.some(specialty => primaryCareSpecialties.includes(specialty));}

export { isPrimaryCare }
